import { PersonalizeProductComponent } from './../personalize-product/personalize-product.component';
import { Subscription, Subject, combineLatest } from 'rxjs';
import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { IngredientService } from '../../../services/ingredient/ingredient.service';
import { ProductService } from '../../../services/product/product.service';
import { MenuService } from '../../../services/menu/menu.service';
import { OrdersService } from '../../../services/order/orders.service';
// import { OptionsSuppModalComponent } from '../options-supp-modal/options-supp-modal.component';
import { ToastContainerDirective } from 'ngx-toastr';

@Component({
    selector: 'menu-modal',
    templateUrl: 'menu-modal.component.html',
    styleUrls: ['menu-modal.component.scss'],
    providers: [MenuService, IngredientService, ProductService]
})
export class MenuModalComponent {
    menu: any = {};
    menuCategory: string = "";
    modalRef: BsModalRef;
    modalRef2: BsModalRef;
    modalRef3: BsModalRef;
    config = {
        ignoreBackdropClick: true
    };
    subscriptions: Subscription[] = [];
    subscriptions2: Subscription[] = [];
    host = "";
    enableAddButton = false;
    loader = true;
    goToNext: Subject<number> = new Subject<number>();
    checkEnableAddButton: Subject<number> = new Subject<number>();
    chosenOrderType;
    identif = 0;
    orderProg;

    @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;

    constructor(
        public bsModalRef: BsModalRef,
        private modalService: BsModalService,
        private menuService: MenuService,
        private changeDetection: ChangeDetectorRef,
        private orderService: OrdersService,
    ) {
        const subs6 = this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
        });
        const subs8 = this.orderService.orderProg.subscribe((orderProg) => {
            this.orderProg = orderProg;
        });
        this.subscriptions2.push(subs6, subs8);
    }

    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }

    ngOnDestroy() {
        this.unsubscribe2();
    }


    PersonalizeModal(product, next) {
        if (product.available && (product.compositions.length > 0 || product.maxNbrIngOptions > 0 || product.hasSupp)) {
            const _combine = combineLatest(
                this.modalService.onHidden
            ).subscribe(() => this.changeDetection.markForCheck());
            this.subscriptions.push(
                this.modalService.onHidden.subscribe((data: any) => {
                    if (data && next) {
                        this.next();
                    }
                    this.unsubscribe();
                })
            );
            this.subscriptions.push(_combine);
            this.modalRef2 = this.modalService.show(PersonalizeProductComponent, { class: 'modal-content3' });
            this.modalRef2.content.product = product;
            this.modalRef2.content.ismenuproduct = true
        }
    }

    // AddOptionsSupp(options) {
    //     const initialState = {
    //         keyboard: false,
    //         backdrop: false,
    //         ignoreBackdropClick: true,
    //         class: 'modal-content-options'
    //     };
    //     const _combine = combineLatest(
    //         this.modalService.onHidden
    //     ).subscribe(() => this.changeDetection.markForCheck());
    //     this.subscriptions.push(
    //         this.modalService.onHidden.subscribe((data: any) => {
    //                 this.orderService.addMenu(this.menu,this.toastContainer).then(
    //                     (d) => {
    //                         this.bsModalRef.hide();
    //                     }, (err) => {
    //                         console.log(err);
    //                     }
    //                 )
    //             this.unsubscribe();
    //         })
    //     );
    //     this.subscriptions.push(_combine);
    //     this.modalRef3 = this.modalService.show(OptionsSuppModalComponent, initialState);
    //     this.modalRef3.content.options = options;

    // }

    ngOnInit() {
        setTimeout(
            () => {
                this.menu.choix = [
                    { checked: false },
                    { checked: false },
                    { checked: false },
                    { checked: false },
                    { checked: false },
                    { checked: false },
                    { checked: false },
                ]
                this.menu.additionalOptions = [];
                this.menu.compositions2 = [];
                this.menuService.getMenuCompositions(this.menu.id, this.chosenOrderType, this.orderProg).subscribe(
                    (data: any) => {
                        this.loader = false;
                        this.menu.compositions2 = data;
                        this.menu.compositions2.forEach((compsition, ind) => {
                            if (ind > 0 && compsition.length > 0) {
                                compsition.checked = 0;
                            }
                            compsition.forEach(comp => {
                                if (comp.type == 2) {
                                    comp.elements.forEach((element, l) => {
                                        element.selectedElement = element.findIndex(e => e.available);
                                    });
                                }
                            });
                        });
                    }
                )
                this.menuService.getMenuAdditionalOptionss(this.menu.id).subscribe(
                    (data: any) => {
                        this.loader = false;
                        this.menu.additionalOptions = data.map(
                            addOpt => {
                                addOpt.text = addOpt.name + " ( " + addOpt.size + " " + addOpt.price + "€ )";
                                addOpt.disabled = (addOpt.available) ? false : true;
                                return addOpt;
                            }
                        )
                    }
                )
            }, 100
        )
    }
    clickProd(id) {
        this.identif = id;
    }
    addToBasket() {
        // if (this.menu.additionalOptions.length > 0) {
        //     this.AddOptionsSupp(this.menu.additionalOptions);
        // } else {
        this.orderService.addMenu(this.menu, this.toastContainer).then(
            (d) => {
                this.bsModalRef.hide();
            }, (err) => {
                console.log(err);
            }
        )
        // }

    }
    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    change(event) {
        this.enableAddButton = event;
    }
    next() {
        this.goToNext.next();
    }
    setEnableAddButton() {
        this.checkEnableAddButton.next();
    }
}